/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useDispatch, useSelector } from "react-redux";
import { addCart } from "../../redux/slices/Cart";
import { useEffect, useState } from "react";
import { imgUrl } from "../utils/imgUrl";

const CartRow = ({ e, index }) => {
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cart.cart);

  const [size, setSize] = useState([]);

  useEffect(() => {
    const sizes = cartData.map((e) => e?.size);
    setSize(sizes);
  }, [cartData]);

  const handleRemoveItem = (index) => {
    const updatedCart = cartData.filter((_, i) => i !== index);

    dispatch(addCart(updatedCart));
  };

  return (
    <tr>
      <td className="pro_img">
        <img
          src={imgUrl + e?.images[0]?.name}
          alt="product"
          className="img-fluid w-100"
        />
      </td>
      <td className="pro_name ">
        <a href="#" className="ps-5">
          {e?.name}
        </a>
        <p className="mt-2 ps-5">
          <strong>Selected Size :</strong> {e?.size}
        </p>
        {e?.product_ingredient_categories?.map((ingredient, index) => (
          <p className="mt-2 ps-5" key={index}>
            <strong>{ingredient?.categoryName}:</strong>{" "}
            {ingredient?.subIngredient?.name}
          </p>
        ))}
      </td>
      <td className="pro_status">
        <h6>${e?.price}</h6>
      </td>
      <td className="pro_select">
        <div className="quentity_btn">
          <button
            className="btn btn-danger"
            onClick={() => {
              if (e?.quantity > 1) {
                dispatch(
                  addCart(
                    cartData.map((item) =>
                      item?.id === e?.id && item?.size === e?.size
                        ? {
                            ...item,
                            quantity: e.quantity - 1,
                            prodactTotal: (e?.quantity - 1) * e?.price,
                          }
                        : item
                    )
                  )
                );
              }
            }}
          >
            <i className="fal fa-minus" />
          </button>
          <input type="text" disabled value={e?.quantity} placeholder={1} />
          <button
            className="btn btn-success"
            onClick={() =>
              dispatch(
                addCart(
                  cartData.map((item) =>
                    item?.id === e?.id && item?.size === e?.size
                      ? {
                          ...item,
                          quantity: e.quantity + 1,
                          prodactTotal: (e?.quantity + 1) * e?.price,
                        }
                      : item
                  )
                )
              )
            }
          >
            <i className="fal fa-plus" />
          </button>
        </div>
      </td>
      <td className="pro_tk">
        <h6>${e?.quantity * e?.price}</h6>
      </td>
      <td className="pro_icon">
        <a href="#" onClick={() => handleRemoveItem(index)}>
          <i className="far fa-times" />
        </a>
      </td>
    </tr>
  );
};

export default function ItemTabel() {
  const cartData = useSelector((state) => state.cart.cart);
  return (
    <section className="cart_view mt_100 xs_mt_70 mb_100 xs_mb_70">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 wow fadeInUp" data-wow-duration="1s">
            <div className="cart_list">
              <div className="table-responsive">
                <table>
                  <tbody>
                    <tr>
                      <th className="pro_img">Image</th>
                      <th className="pro_name">Name</th>
                      <th className="pro_status">price</th>
                      <th className="pro_select">quantity</th>
                      <th className="pro_tk">total</th>
                      <th className="pro_icon">
                        <a className="clear_all" href="#">
                          clear all
                        </a>
                      </th>
                    </tr>
                    {cartData?.map((e, i) => (
                      <CartRow key={i} index={i} e={e} />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
